import api from "./api";
import API_ENDPOINTS from "./apiEndpoints";

export const fetchSettings = async () => {
  const res = await api.get(API_ENDPOINTS.FETCH_SETTINGS);
  return res.data;
};

export const updateSettings = async (payload) => {
  const res = await api.put(API_ENDPOINTS.UPDATE_SETTINGS, payload);
  return res.data;
};
